import { Component, OnInit } from '@angular/core';
import { AlertasService } from '../../alerta_servicio/alertas.service'
import { ActivatedRoute } from '@angular/router';
import { HttpClientAuthServiceService } from '../../httpServices/http-client-auth-service.service'

import { AutorizacionDatosService } from '../../httpServices/autorizacion-datos.service'

@Component({
  selector: 'aceptar-app-terminos-condiciones',
  templateUrl: './aceptar-terminos-condiciones.component.html',
  styleUrls: ['./aceptar-terminos-condiciones.component.css']
})
export class AceptarTerminosCondicionesComponent implements OnInit {


  public idAutorizacion: string;
  public tipoDocumento: string;
  public numeroIdentificacion: string;
  public celular: string;
  public primerNombre: string;
  public segundoNombre: string;
  public primerApellido: string;
  public segundoApellido: string;

  public razonSocial: string;
  public numeroIdentificacionRL: string;
  public codigoTransaccion: string;
  public id: string;
  public checkUno: boolean;
  public checkDos: boolean;
  public loading_page: boolean = false;

  public confirmacion: boolean;
  public confirmacionRespuesta: boolean;
  public vigente: boolean;

  constructor(protected httpService: HttpClientAuthServiceService,
    private alertas: AlertasService, private route: ActivatedRoute,
    protected autorizacionDatosService: AutorizacionDatosService) { }

  async ngOnInit(): Promise<void> {
    this.checkUno = false;
    this.checkDos = false;

    await this.httpService.login();
    this.route.queryParams.subscribe(params => {
      this.id = params['token'];
    });

    if (this.id != null) {
      this.loading_page = true;
      const splitted = this.id.toString().split("-");
      this.idAutorizacion = splitted[0];
      this.tipoDocumento = splitted[1];
      this.numeroIdentificacion = splitted[2];
      this.celular = splitted[3];
      this.primerNombre = splitted[4].replace(/_/g, ' ').replace(/nnn/g, 'ñ').replace(/NNN/g, 'Ñ');
      this.segundoNombre = splitted[5].replace(/_/g, ' ').replace(/nnn/g, 'ñ').replace(/NNN/g, 'Ñ');
      this.primerApellido = splitted[6].replace(/_/g, ' ').replace(/nnn/g, 'ñ').replace(/NNN/g, 'Ñ');
      this.segundoApellido = splitted[7].replace(/_/g, ' ').replace(/nnn/g, 'ñ').replace(/NNN/g, 'Ñ');
      this.codigoTransaccion = splitted[8];

      if (this.tipoDocumento === "3") {

        this.razonSocial= splitted[9].replace(/_/g, ' ').replace(/nnn/g, 'ñ').replace(/NNN/g, 'Ñ');
        this.numeroIdentificacionRL= splitted[10];
        this.razonSocial = this.razonSocial.replace(/_/g, ' ').replace(/nnn/g, 'ñ').replace(/NNN/g, 'Ñ');
      }


    }

  }


  confirmarAutorizacionDatos() {

   // console.log('checkUno' + this.checkUno);
  //  console.log('checkDos' + this.checkDos);
  //  console.log('primerNombre' + this.primerNombre);
  //  console.log('primerApellido' + this.primerApellido);


   // if (this.checkUno == true && this.checkDos == true) {

      if (this.primerNombre !== null && this.primerNombre.trim() !== '') {
        if (this.primerApellido !== null && this.primerApellido.trim() !== '') {





          this.autorizacionDatosService.getAutorizacionDatos_(this.idAutorizacion).subscribe(confirmado => {
            if (confirmado) {
              // La autorización está confirmada
          //    console.log('confirmado ' + confirmado)
              this.alertas.showSuccess(
                'Proceso Autorización Finalizado Fue Realizado Exitosamente',
                'Información'
              );
            } else {
              // La autorización no está confirmada

            //  console.log('no confirmado ' + confirmado)
              this.autorizacionDatosService.aprobarAutorizacionDatos_(this.idAutorizacion,
                this.tipoDocumento,
                this.numeroIdentificacion,
                this.primerNombre,
                this.segundoNombre,
                this.primerApellido,
                this.segundoApellido
              ).subscribe(
                (data) => {
                  // Success
                  this.confirmacionRespuesta = data.body['data']['confirmado'];
                  this.vigente = data.body['data']['vigente'];
                  if (this.vigente == false) {
                    this.alertas.showError(
                      '',
                      'El Proceso de autorización de datos no esta vigente'
                    );
                    setTimeout(() => {
                      window.location.href = 'https://www.mundofinanciera.com/#/';
                    }, 3000);
                  }
                  if (this.confirmacionRespuesta == true) {
                    this.alertas.showSuccess(
                      'Proceso Autorización Finalizado',
                      'Información'
                    );
                    setTimeout(() => {
                      window.location.href = 'https://www.mundofinanciera.com/#/';
                    }, 3000);
                  }
                },
                (error) => {
                  this.alertas.showError(error.error["message"], "Error registrando la autorización");
                }
              );

            }
          });

        } else {
          this.alertas.showError(
            '',
            'El primer apellido es obligatorio'
          );
        }
      } else {
        this.alertas.showError(
          '',
          'El primer nombre es obligatorio'
        );
      }
   /* } else {
      this.alertas.showError(
        '',
        'Debe marcar todas las casillas verificables aceptando los términos y condiciones'
      );
    }*/

  }


}
